import { NgModule } from '@angular/core';

import { MasterMasterGroupsUsersActions } from './master-master-groups-users.actions';

@NgModule({
  providers: [
    MasterMasterGroupsUsersActions
  ]
})
export class MasterMasterGroupsUsersActionsModule {}
